import { useCallback } from 'react';
import { getInitialStateForFileSettings } from '../utils';
import { DataRoomSecuritySettings } from '../models/DataRoom';

export default function useFileSecurityInitialValues() {
  return useCallback(
    ({
      downloadSecurePdf,
      hasExpiration,
      expirationDays,
      includeWatermark,
      watermarkDiagonal,
      watermarkHeader,
      watermarkFooter,
      watermarkFullName,
      watermarkEmail,
      watermarkIpAddress,
    }: DataRoomSecuritySettings) => ({
      expirationDays,
      downloadSecurePdf: getInitialStateForFileSettings(downloadSecurePdf),
      hasExpiration: getInitialStateForFileSettings(hasExpiration),
      includeWatermark: getInitialStateForFileSettings(includeWatermark),
      watermarkDiagonal: getInitialStateForFileSettings(watermarkDiagonal),
      watermarkHeader: getInitialStateForFileSettings(watermarkHeader),
      watermarkFooter: getInitialStateForFileSettings(watermarkFooter),
      watermarkFullName: getInitialStateForFileSettings(watermarkFullName),
      watermarkEmail: getInitialStateForFileSettings(watermarkEmail),
      watermarkIpAddress: getInitialStateForFileSettings(watermarkIpAddress),
    }),
    [],
  );
}
